import { Pipe, PipeTransform } from '@angular/core';
import { ErrorManagerService } from '../services/error-manager.service';

@Pipe({
    name: 'errorMessage',
    standalone: false
})
export class ErrorMessagePipe implements PipeTransform {

  constructor(private errorManager: ErrorManagerService) {
  }

  transform(errorData: {error: string; message?: string} | string): string {
    return this.errorManager.getMessage(errorData);
  }

}
